// extracted by mini-css-extract-plugin
export var createdDate = "_m5-1";
export var divider = "_m5-2";
export var headerDivider = "_m5-3";
export var messagesCard = "_m5-0";
export var messagesContainer = "_m5-6";
export var messagesContainerWrapper = "_m5-4";
export var showLeftPanelButton = "_m5-8";
export var topButtons = "_m5-7";
export var withPadding = "_m5-5";